<button class="btn" (click)="onClick()" title="Logout">
  <img class="logout__icon" src="assets/ui/icon-logout-white.svg" alt="Logout" />
</button>
